import { render, staticRenderFns } from "./InsulationMaterial.vue?vue&type=template&id=9f062e42&scoped=true&"
import script from "./InsulationMaterial.vue?vue&type=script&lang=js&"
export * from "./InsulationMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f062e42",
  null
  
)

export default component.exports